<template>
  <div class="vehicle text-left">
    <p class="text-2xl font-bold mb-6">Pilih Pickup Layanan</p>
    <div
      class="mb-4 last:mb-6 cursor-pointer border rounded-md px-3 py-2 flex justify-between items-center"
      :class="{ 'bg-primary-100 border border-primary-500': selectedPickup?.id === pickup.id }"
      v-for="pickup in deliveryServicesPickup[0]?.packages"
      :key="pickup.id"
      @click="selectPickup(pickup)"
    >
      <div>
        <p class="text-sm font-medium">{{ pickup?.name }}</p>
        <p class="text-xs">Berat barang {{ pickup?.minimum_weight }} - {{ pickup?.maximum_weight }} kg</p>
      </div>
      <div>
        <p class="text-sm font-medium text-right">{{ pickup?.shipment_cost | currencyFormat }}</p>
        <p class="text-xs text-right">{{ pickup?.est_delivery_time_range_min }} - {{ pickup?.est_delivery_time_range_max }}</p>
      </div>
    </div>
    <div class="flex justify-end items-center gap-4 mt-6">
      <Button buttonText="Cancel" type="secondary" @action="closeModal()" />
      <Button buttonText="Apply" type="primary" @action="apply()" :disabled="!selectedPickup" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { currencyFormat } from '@/util'
export default {
  components: {
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button')
  },
  filters: {
    currencyFormat
  },
  data() {
    return {
      selectedPickup: null,
      logisticInfo: null
    }
  },
  props: {
    nearestHub: {
      type: Object,
      default: () => {}
    },
    shippingInfo: {
      type: Object,
      default: () => {}
    },
    deliveryServiceId: {
      type: String,
      default: null
    }
  },
  mounted() {
    this.getDeliveryServicesInfo()
  },
  computed: {
    ...mapGetters('merchant', ['deliveryServicesPickup'])
  },
  methods: {
    ...mapActions('merchant', ['getDeliveryServicesPickup']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    apply() {
      this.$emit('pickup', this.selectedPickup)
    },
    selectPickup(pickup) {
      this.selectedPickup = pickup
    },
    closeModal() {
      this.$emit('close')
    },
    getDeliveryServicesInfo() {
      let self = this
      this.showLoading()
      this.getDeliveryServicesPickup({
        params: {
          page: 1,
          per_page: 10,
          search_keyword: '',
          sort: 'ASC',
          origin_city: self.shippingInfo.hub.origin.code,
          destination_city: self.nearestHub.area_code,
          goods_category: self.shippingInfo.hub.goodsCategory,
          package_size: '',
          delivery_service_id: this.deliveryServiceId,
          delivery_service_type: 'P',
          package_size_type: self.shippingInfo.package.code,
          delivery_service_package: ''
        }
      }).then(() => {
        this.hideLoading()
        const logistic = localStorage.getItem('order_logistic')
        if (logistic) {
          this.logisticInfo = JSON.parse(logistic)
          this.selectedPickup = this.logisticInfo.pickup
        }
      })
    }
  }
}
</script>
